import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestWorkspaceUserCreditsLimitReset } from '@shared/dto/+workspace/workspace_user/_requests/request_workspace_user_credits_limit_reset';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__workspace } from '../STATE__workspace';

export const remote_workspace_user_credits_limit_reset = createAsyncThunkSafe<void, RequestWorkspaceUserCreditsLimitReset>(
  ENUM__network_event_client_to_server.WORKSPACE_USER_USER_CREDITS_LIMIT_RESET,
  async (request): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_USER_USER_CREDITS_LIMIT_RESET, request);
  },
);

export function init_remote_workspace_user_credits_limit_reset(builder: ActionReducerMapBuilder<STATE__workspace>) {
  builder
    .addCase(remote_workspace_user_credits_limit_reset.pending, (state, action) => {})
    .addCase(remote_workspace_user_credits_limit_reset.rejected, (state, action) => {})
    .addCase(remote_workspace_user_credits_limit_reset.fulfilled, (state, action: PayloadAction) => {});
}
